<template>
  <path pid="0" d="M4 16.28h7.86L11 23.15a1 1 0 001.76.77l10-12a1 1 0 00-.76-1.64h-7.89L15 3.4a1 1 0 00-1.76-.76l-10 12A1 1 0 004 16.28zm8.58-9.74L12 11.15a1 1 0 001 1.13h6.86L13.39 20l.61-4.6a1 1 0 00-1-1.12H6.11z"/>
</template>
